import { Component, OnInit } from '@angular/core';
import { UTrackUIEvent } from '@app/models/utrack-ui-event';
import { VennHealthDataService } from '@app/services/vennhealth-data.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  portalUrl = environment.tessellonPortalLoginUrl;

  constructor(private readonly vennhealthDataService: VennHealthDataService) { }

  ngOnInit(): void {
    const e: UTrackUIEvent = {
      details: 'Not Found',
      additionalDetails: ''
    };
    this.vennhealthDataService.utrackEvent(e).subscribe();
  }

}
